import type { B2BRegistrationBase, CreateB2BRegistrationRequest } from 'api/requestTypes';

const appendOptionalString = (
  out: Record<string, unknown>,
  key: string,
  value: string | undefined,
): void => {
  if (value === undefined || value === '') {
    return;
  }
  out[key] = value;
};

const buildBaseFields = (req: B2BRegistrationBase): Record<string, unknown> => {
  const out: Record<string, unknown> = {
    fullName: req.fullName,
    phoneNumber: req.phoneNumber,
    city: req.city,
    hasOrganizedBefore: req.hasOrganizedBefore,
    eventName: req.eventName,
    description: req.description,
    isVenueConfirmed: req.isVenueConfirmed,
  };

  appendOptionalString(out, 'companyOrOrganization', req.companyOrOrganization);
  appendOptionalString(out, 'email', req.email);
  appendOptionalString(out, 'websiteOrSocialMedia', req.websiteOrSocialMedia);
  appendOptionalString(out, 'eventDate', req.eventDate);
  appendOptionalString(out, 'eventTime', req.eventTime);
  appendOptionalString(out, 'eventVenue', req.eventVenue);

  if (req.hasOrganizedBefore === true) {
    appendOptionalString(out, 'previousEvents', req.previousEvents);
  }

  return out;
};

/**
 * Plain JSON body for POST /consumers/b2b/register.
 * - Omits optional keys when empty (prefer omit over "").
 * - Always includes `publicEventCategory` for every `eventType`.
 */
export const buildB2BRegistrationRequestBody = (
  req: CreateB2BRegistrationRequest,
): Record<string, unknown> => ({
  ...buildBaseFields(req),
  eventType: req.eventType,
  publicEventCategory: req.publicEventCategory,
});
